

























import {
  computed,
  defineComponent,
  ref,
} from '@nuxtjs/composition-api';
import {
  SfCheckbox,
  SfHeading,
} from '@storefront-ui/vue';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { digits, min, required } from 'vee-validate/dist/rules';
import JetInput from '~/components/JetUi/atoms/Input/JetInput.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import BillingAddress from '~/components/JetUi/organisms/Checkout/BillingAddress.vue';

import { storeToRefs } from 'pinia';
import Warning from '~/components/JetUi/atoms/Warning/Warning.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useCheckout, useCheckoutStore } from '~/stores/checkout';

extend('required', {
  ...required,
  message: 'This field is required',
});
extend('min', {
  ...min,
  message: 'The field should have at least {length} characters',
});
extend('digits', {
  ...digits,
  message: 'Please provide a valid phone number',
});

export default defineComponent({
  name: 'BillingStep',
  components: {
    SkeletonLoader,
    SfHeading,
    JetInput,
    SfCheckbox,
    ValidationProvider,
    ValidationObserver,
    BillingAddress,
    Warning,
    JetUiButton,
  },
  setup() {
    const setAsDefault = ref(false);
    const {
      isAuthenticated,
      hasSavedAddress: hasSavedBillingAddress,
      countries,
      addresses,
      loaded,
      handleSetCurrentAddress,
    } = useCheckout('billing');
    const { currentBillingAddressId } = storeToRefs(useCheckoutStore());

    // watch(currentBillingAddressId, async (newAddressId) => {
    //   if (newAddressId) {
    //     await handleSetCurrentAddress(addresses.value.find((address) => address.id === newAddressId));
    //   }
    // })

    return {
      countries,
      currentAddressId: currentBillingAddressId,
      handleSetCurrentAddress,
      hasSavedBillingAddress,
      isAuthenticated,
      addresses: computed(() => addresses.value),
      loaded,
      setAsDefault,
    };
  },
});
